import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
export function HomeProblem() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-532" data-mp="5ul5st9bbt8o">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-533" data-mp="jst1yyyiyqis">
        <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark leading-tight tracking-tight" data-id="element-534" data-mp="fq63if7cm7cm">
          Intelligence is more than information
        </h2>
        <div className="lg:col-span-7 space-y-8" data-id="element-535" data-mp="orckepdwtk6e">
          <p className="text-2xl text-ink-dark leading-relaxed" data-id="element-536" data-mp="13gscq9t39xo7">
            The world has more information than ever, yet people and
            institutions still struggle to judge what is credible, see how
            evidence connects, and act wisely under pressure.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed border-l-2 border-teal pl-6" data-id="element-537" data-mp="1cfdp1n7ywggj">
            SyNeural works on both sides of that problem: strengthening the
            human capacity for judgment and building knowledge systems that make
            complex information easier to understand and use.
          </p>
        </div>
      </motion.div>
    </section>;
}